import { addToGlobalThisRet } from "@plugins";

function initProfessionalInstallationCheckboxesListeners() {
    const profInstallationItems = document.querySelectorAll(".js-professional-installation");

    for (const item of profInstallationItems) {
        const checkbox = item.querySelector(".js-professional-installation-input");

        checkbox.addEventListener("click", () => {
            const tip = item.querySelector(".js-professional-installation-tip");

            tip.classList[checkbox.checked ? "remove" : "add"]("hidden");
        });
    }
}

window.addEventListener("load", () => initProfessionalInstallationCheckboxesListeners());

addToGlobalThisRet(
    initProfessionalInstallationCheckboxesListeners,
    "initProfessionalInstallationCheckboxesListeners",
);
